<script>
import Label from '@/components(new)/UI/Forms/Label/Label.vue'
import { formataStringYearMonthToBr } from '@/utils/utils'

export default {
  components: {
    Label
  },
  props: {
    titleCard: {
      type: String
    },
    infosCard: {
      type: Array,
      default: () => [
        {label: 'example label:', descricao: 'descricao'},
        {label: 'example label 2:', descricao: 'descricao'}
      ]
    },
    groupCards: {
      type: Boolean,
      default: false
    },
    exibirInfoCards: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    formataDescricao (label, descricao) {
      if (label.toLowerCase().includes('data')) {
        return formataStringYearMonthToBr(descricao)
      } else if (label.toLowerCase().includes('área')) {
        return descricao.toString().replace('.', ',')
      } else {
        return descricao
      }
    }
  }
}
</script>

<template>
  <div :class="groupCards ? 'card-container mt-2 flex-start g-2' : 'card-container mt-2'">
    <el-card>
      <div class="flex-aligned">
        <div class="mr-5" v-show="exibirInfoCards">
          <h2>{{ titleCard }}</h2>
          <div class="card-info-container mt-2">
            <div v-for="(info, index) in infosCard" :key="index">
              <Label :label="info.label + ': ' + formataDescricao(info.label, info.descricao)" />
            </div>
          </div>
        </div>
        <slot name="info-card"></slot>
      </div>
    </el-card>
  </div>
</template>



// WEBPACK FOOTER //
// src/components(new)/UI/Cards/CardBase/CardBase.vue